import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import NewsCard from "@/components/feature/NewsCard";
import { newsList } from "@/mocks/news";

export default function NewsSpotlight() {
  const featured = newsList[0];
  const rest = newsList.slice(1, 5);

  return (
    <section aria-labelledby="home-news-heading" className="w-full px-4 md:px-6 lg:px-10 py-10 md:py-14">
      <SectionHeading
        kicker="NEWS"
        title="资讯精选"
        description="按时间整理的最新动漫行业动态、新番情报与深度报道。"
        actionLabel="查看全部资讯"
        actionTo="/news"
      />
      <div id="home-news-heading" className="sr-only">资讯精选</div>
      {!featured ? (
        <p className="text-sm text-foreground-500">暂无相关内容</p>
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5">
          <Link
            to={`/news/detail/${featured.id}`}
            className="group flex flex-col rounded-lg border border-background-200 bg-background-50 overflow-hidden hover:border-primary-200 transition-colors cursor-pointer"
          >
            <div className="w-full aspect-[16/9] overflow-hidden bg-background-200">
              <img
                src={featured.cover}
                alt={`${featured.title} - age动漫头条资讯`}
                title={`${featured.title} - 动漫资讯`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
              />
            </div>
            <div className="p-4 md:p-5">
              <div className="flex items-center gap-2 text-[11px] text-foreground-400 mb-2">
                <span className="px-2 py-0.5 rounded bg-primary-50 text-primary-700">头条</span>
                <span className="px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-900">{featured.tag}</span>
                <span>{featured.publishedAt}</span>
              </div>
              <h3 className="text-lg md:text-xl font-bold text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors">
                {featured.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-500 leading-relaxed line-clamp-2">{featured.summary}</p>
              <span className="inline-flex items-center gap-1 mt-3 text-sm text-primary-600 font-medium">
                阅读全文
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5"></i>
              </span>
            </div>
          </Link>

          <div className="flex flex-col gap-3">
            {rest.map((item) => (
              <NewsCard key={item.id} item={item} variant="list" />
            ))}
          </div>
        </div>
      )}
    </section>
  );
}